import React, { useState, useEffect } from "react";
import "../css/Footer.css"; // Dedicated styles

import { NavLink } from "react-router-dom";
// Import highly descriptive modern icons from FontAwesome
import {
  FaPhoneAlt,
  FaEnvelope,
  FaInfoCircle,
  FaAddressBook,
  FaAward,
  FaGavel,
  FaFileContract,
  FaLaptopCode,
  FaBookReader,
  FaChartLine,
  FaSchool,
  FaComments,
  FaGift,
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaYoutube,
  FaLinkedinIn,
  FaGraduationCap,
  FaRocket,
  FaMobileAlt,
  FaQuestionCircle,
  FaUserGraduate,
  FaFileAlt,
  FaClipboardCheck,
  FaUserCog,
  FaCogs,
  FaUserTie,
  FaBroom,
  FaWrench,
  FaBolt,
  FaSnowflake,
  FaPaintRoller,
  FaBug,
  FaUserPlus,
  FaClipboardList,
  FaHeadset,
  FaTshirt

} from "react-icons/fa";

// Import your brand assets here
import footerBg from "../../images/Banner8.png";
import brandLogo from "../../images/logo.png";

function Footer() {
  const [showScrollTop, setShowScrollTop] = useState(false);

  // Monitor scroll position to toggle back-to-top button visibility
  useEffect(() => {
    const checkScrollTop = () => {
      if (!showScrollTop && window.pageYOffset > 300) {
        setShowScrollTop(true);
      } else if (showScrollTop && window.pageYOffset <= 300) {
        setShowScrollTop(false);
      }
    };

    window.addEventListener("scroll", checkScrollTop);
    return () => window.removeEventListener("scroll", checkScrollTop);
  }, [showScrollTop]);

  return (
    <footer
      className="main-footer"
      style={{ backgroundImage: `url(${footerBg})` }}
    >
      <div className="footer-main-container">
        <div className="footer-columns-row">

          {/* Column 1: Brand details & contacts */}
          {/* Column 1: Brand */}

          <div className="footer-col-brand footer-col-item">
            <div className="footer-brand-column">


              <img
                src={brandLogo}
                alt="Fixovera Logo"
                className="footer-logo mb-3"
              />

              <p className="footer-description">
                Fixovera is a trusted household services marketplace connecting customers
                with verified professionals for reliable, convenient, and hassle-free
                home services.
              </p>

              <div className="footer-contacts">

                <p className="contact-item">
                  <FaPhoneAlt className="contact-icon" />
                  <strong>P:</strong>
                  <a
                    href="tel:+916290 424 024"
                    className="contact-phone-link"
                  >
                    + (91) 6290 425 024
                  </a>
                </p>



                <p className="contact-item email-highlight">
                  <FaEnvelope className="contact-icon" />
                  <strong>E:</strong>
                  <a href="mailto:info@fixovera.com">
                    info@fixovera.com
                  </a>
                </p>

              </div>
            </div>


          </div>

          {/* Column 2: Company */}

          <div className="footer-col-link footer-col-item">
            <div className="footer-links-column">


              <h4 className="footer-heading">
                Company
              </h4>

              <ul className="footer-list">

                <li>
                  <NavLink to="/about">
                    <FaInfoCircle className="link-icon" />
                    About Fixovera
                  </NavLink>
                </li>

                <li>
                  <NavLink to="/customer-reviews">
                    <FaCogs className="link-icon" />
                    Our Reviews
                  </NavLink>
                </li>

                <li>
                  <NavLink to="/contact">
                    <FaAddressBook className="link-icon" />
                    Contact Us
                  </NavLink>
                </li>

                <li>
                  <a
                    href="https://admin.fixovera.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaUserTie className="link-icon" />
                    Admin Access
                  </a>
                </li>

              </ul>

            </div>


          </div>

          {/* Column 3: Services */}

          <div className="footer-col-link footer-col-item">
            <div className="footer-links-column">

              <h4 className="footer-heading">
                Services
              </h4>

              <ul className="footer-list">

                {/* AC */}
                <li>
                  <NavLink to="/ac">
                    <FaSnowflake className="link-icon" />
                    AC Services
                  </NavLink>
                </li>

                {/* Washing Machine */}
                <li>
                  <NavLink to="/washing-machine">
                    <FaTshirt className="link-icon" />
                    Washing Machine
                  </NavLink>
                </li>

              </ul>

            </div>
          </div>

          {/* Column 4: For Partners */}

          <div className="footer-col-link footer-col-item">
            <div className="footer-links-column">


              <h4 className="footer-heading">
                For Partners
              </h4>

              <ul className="footer-list">

                <li>
                  <NavLink to="#">
                    <FaUserPlus className="link-icon" />
                    Become a Partner
                  </NavLink>
                </li>

                <li>
                  <NavLink to="/partner-benefits">
                    <FaAward className="link-icon" />
                    Partner Benefits
                  </NavLink>
                </li>

                <li>
                  <NavLink to="/partner-registration">
                    <FaClipboardList className="link-icon" />
                    Partner Registration
                  </NavLink>
                </li>

                <li>
                  <NavLink to="/contact">
                    <FaHeadset className="link-icon" />
                    Partner Support
                  </NavLink>
                </li>

              </ul>

            </div>


          </div>

          {/* Column 5: Quick Links */}

          <div className="footer-col-link footer-col-item">
            <div className="footer-links-column">


              <h4 className="footer-heading">
                Quick Links
              </h4>

              <ul className="footer-list">

                <li>
                  <NavLink to="/faq">
                    <FaQuestionCircle className="link-icon" />
                    FAQs
                  </NavLink>
                </li>

                <li>
                  <NavLink to="/privacy-policy">
                    <FaFileContract className="link-icon" />
                    Privacy Policy
                  </NavLink>
                </li>

                <li>
                  <NavLink to="/terms-and-conditions">
                    <FaGavel className="link-icon" />
                    Terms & Conditions
                  </NavLink>
                </li>

                <li>
                  <NavLink to="/refund-policy">
                    <FaFileAlt className="link-icon" />
                    Refund Policy
                  </NavLink>
                </li>

              </ul>

            </div>


          </div>

          {/* Column 6: Connect */}

          <div className="footer-col-link footer-col-item">
            <div className="footer-links-column">


              <h4 className="footer-heading">
                Connect
              </h4>

              <ul className="footer-list">

                <li>
                  <a
                    href="https://www.facebook.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaFacebookF className="link-icon" />
                    Facebook
                  </a>
                </li>

                <li>
                  <a
                    href="https://www.instagram.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaInstagram className="link-icon" />
                    Instagram
                  </a>
                </li>

                <li>
                  <a
                    href="https://x.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaTwitter className="link-icon" />
                    X (Twitter)
                  </a>
                </li>

                <li>
                  <a
                    href="https://www.youtube.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaYoutube className="link-icon" />
                    YouTube
                  </a>
                </li>

                <li>
                  <a
                    href="https://www.linkedin.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaLinkedinIn className="link-icon" />
                    LinkedIn
                  </a>
                </li>

              </ul>

            </div>


          </div>


        </div>

        {/* Dynamic Horizontal Line Splitter */}
        <hr className="footer-divider" />

        {/* Copyright strip */}
        <div className="footer-bottom-strip">
          <p className="footer-copyright mb-0 text-center">
            &copy; {new Date().getFullYear()} Fixovera. All Rights Reserved. Developed and managed by{" "}
            <a
              href="https://restartsoftwares.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Restart Softwares
            </a>
          </p>
        </div>

      </div>
    </footer>
  );
}

export default Footer;